export default "__VITE_ASSET__CGmo9enq__"